module.exports = __webpack_public_path__ + "img/macbook.ba821689.png";